import { render } from "./BaseSelector.vue?vue&type=template&id=7870d5e6"
import script from "./BaseSelector.vue?vue&type=script&lang=js"
export * from "./BaseSelector.vue?vue&type=script&lang=js"
script.render = render

export default script